import { SMALL_SCREEN_WIDTH } from '@/config/constant'

export interface ViewportState {
    width: number
    height: number
    isSmallScreen: boolean
}

const state: ViewportState = {
    width: window.innerWidth,
    height: window.innerHeight,
    isSmallScreen: window.innerWidth < SMALL_SCREEN_WIDTH
}

const getters = {
    viewportWidth: (state: ViewportState) => state.width,
    viewportHeight: (state: ViewportState) => state.height,
    isSmallScreen: (state: ViewportState) => state.isSmallScreen
}
const mutations = {
    SET_VIEWPORT_SIZE(state: ViewportState, { width, height }: { width: number; height: number }) {
        state.width = width
        state.height = height
        state.isSmallScreen = width < SMALL_SCREEN_WIDTH
    },
    INIT_VIEWPORT(state: ViewportState) {
        
        state.width = window.innerWidth
        state.height = window.innerHeight
        state.isSmallScreen = window.innerWidth < SMALL_SCREEN_WIDTH
    }
}

const actions = {
    initViewport({ commit }: any) {
        
        commit('INIT_VIEWPORT')

        window.addEventListener('resize', () => {
            commit('SET_VIEWPORT_SIZE', {
                width: window.innerWidth,
                height: window.innerHeight
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
